function setTextareaValue(element: HTMLTextAreaElement, value: string) {
  const descriptor = Object.getOwnPropertyDescriptor(HTMLTextAreaElement.prototype, "value");
  descriptor?.set?.call(element, value);
}

function normalizeQuestion(item: any) {
  const choices = Array.isArray(item?.choices) ? item.choices : Array.isArray(item?.options) ? item.options : null;
  const answer = item?.answer ?? item?.correctIndex ?? item?.correct;
  return {
    prompt: String(item?.question ?? item?.prompt ?? "").trim(),
    options: choices?.map((choice: unknown) => String(choice ?? "").trim()) ?? [],
    correctIndex: Number(answer),
    explanation: String(item?.explanation ?? item?.explication ?? "").trim(),
  };
}

function normalizeJsonQuestions(text: string) {
  const trimmed = text.trim();
  if (!trimmed.startsWith("[")) return null;
  const raw = JSON.parse(trimmed);
  if (!Array.isArray(raw) || raw.length === 0) return null;
  const looksLikeQuestionList = raw.every((item) => item && typeof item === "object" && (Array.isArray(item.choices) || Array.isArray(item.options)));
  if (!looksLikeQuestionList) return null;

  const normalized = raw.map(normalizeQuestion);
  const valid = normalized.every((item) => item.prompt && item.options.length === 4 && item.options.every(Boolean) && Number.isInteger(item.correctIndex) && item.correctIndex >= 0 && item.correctIndex <= 3);
  if (!valid) return null;
  return JSON.stringify(normalized, null, 2);
}

function isQcmTextarea(target: EventTarget | null): target is HTMLTextAreaElement {
  return target instanceof HTMLTextAreaElement && Boolean(target.closest(".qcm-bulk-field"));
}

// Point clé : on normalise pendant l'événement input, en phase capture.
// React lit donc directement la valeur normalisée, aussi bien pour les prérequis
// que pour les questions liées à une activité.
document.addEventListener("input", (event) => {
  const target = event.target;
  if (!isQcmTextarea(target)) return;
  try {
    const normalized = normalizeJsonQuestions(target.value);
    if (!normalized || normalized === target.value.trim()) return;
    setTextareaValue(target, normalized);
  } catch {
    // Pendant la saisie le JSON peut être temporairement incomplet : on ne bloque rien.
  }
}, true);

document.addEventListener("paste", (event) => {
  const target = event.target;
  if (!isQcmTextarea(target)) return;

  const text = event.clipboardData?.getData("text/plain") ?? "";
  try {
    const normalized = normalizeJsonQuestions(text);
    if (!normalized) return;
    event.preventDefault();
    setTextareaValue(target, normalized);
    target.dispatchEvent(new InputEvent("input", { bubbles: true, inputType: "insertFromPaste", data: normalized }));
  } catch {
    // Le parseur principal affichera son message si le JSON est réellement invalide.
  }
});

// Filet de sécurité au clic : si une ancienne valeur choices/answer est encore
// présente dans l'état React, on la normalise puis on relance le clic au tour suivant.
document.addEventListener("click", (event) => {
  const origin = event.target;
  const button = origin instanceof Element ? origin.closest("button") : null;
  if (!(button instanceof HTMLButtonElement) || !button.closest(".qcm-import-card") || !button.classList.contains("qcm-primary")) return;

  const card = button.closest(".qcm-import-card");
  const textarea = card?.querySelector<HTMLTextAreaElement>(".qcm-bulk-field textarea");
  if (!textarea) return;

  try {
    const normalized = normalizeJsonQuestions(textarea.value);
    if (!normalized || normalized === textarea.value.trim()) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    setTextareaValue(textarea, normalized);
    textarea.dispatchEvent(new InputEvent("input", { bubbles: true, inputType: "insertText", data: normalized }));
    window.setTimeout(() => button.click(), 20);
  } catch {
    // On laisse l'import normal gérer l'erreur JSON.
  }
}, true);
